import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";

import { ReactComponent as PhoneIcon } from "../../../assets/icons/phone.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "relative",
    color: theme.palette.text.primary,
    marginTop: theme.spacing(-0.25),
  },
  top: {
    display: "inline-flex",
  },
  icon: {
    marginRight: theme.spacing(1.25),
    paddingTop: theme.spacing(0.5),
  },
  phoneNumber: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: "600",
    lineHeight: 1,
    "& a": {
      color: "inherit",
    },
  },
  caption: {
    fontSize: "1.12rem"
  }
}));

const PhoneDesktop = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.icon}>
          <PhoneIcon width="20" height="20" />
        </div>
        <Typography className={classes.phoneNumber}>
          <Link href="tel:030555786499">030555786499</Link>
        </Typography>
      </div>
      <Typography className={classes.caption}>Kostenlose Erstberatung</Typography>
    </div>
  );
};

export default PhoneDesktop;
